export default {
  title: 'Marki',
  form: {
    name: {
      placeholder: 'Szukaj marki...',
    },
  },
  fields: {
    id: '#',
    name: 'Nazwa',
    address: 'Adres',
    subdomain: 'Subdomena',
    shop_url: 'URL sklepu',
    companies: 'Firmy',
    slug: 'Slug',
    actions: '',
  },
  empty_list: 'Brak marek',
  modals: {
    delete_franchise: {
      title: 'Czy na pewno chcesz usunąć markę {{name}}?',
    },
  },
  buttons: {
    new_franchise: '+ Dodaj markę',
    export_restaurants: 'Eksportuj restauracje',
    edit: 'Edytuj',
    delete: 'Usuń',
    view_dashboard_as_owner: 'Wyświetl panel jako właściciel',
    open_shop: 'Otwórz sklep',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
    failed_to_delete_franchise: 'Nie udało się usunąć marki',
    franchise_got_deleted: 'Marka została usunięta',
    failed_to_create_magic_link: 'Nie udało się utworzyć magicznego linku',
    no_owner_to_log_in_as: 'Brak właściciela restauracji, na którego można się zalogować',
  },
};
